'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var UPDATE = exports.UPDATE = 'REDUX_ORM_UPDATE';
var DELETE = exports.DELETE = 'REDUX_ORM_DELETE';
var CREATE = exports.CREATE = 'REDUX_ORM_CREATE';

var FILTER = exports.FILTER = 'REDUX_ORM_FILTER';
var EXCLUDE = exports.EXCLUDE = 'REDUX_ORM_EXCLUDE';
var ORDER_BY = exports.ORDER_BY = 'REDUX_ORM_ORDER_BY';

var SUCCESS = exports.SUCCESS = 'SUCCESS';
var FAILURE = exports.FAILURE = 'FAILURE';


//////////////////
// WEBPACK FOOTER
// ../~/redux-orm/lib/constants.js
// module id = 123
// module chunks = 0